const defaultState = () => ({
    route: null,
    data: null,
    timestamp: null
});

export default (state = defaultState(), { type, payload }) => {
    switch (type) {
        case "FORM_PREFILL:SET": {
            return {
                ...state,
                route: payload?.route || null,
                data: payload?.data || null,
                timestamp: Date.now()
            };
        }
        case "FORM_PREFILL:CLEAR": {
            return defaultState();
        }
        default: {
            return state;
        }
    }
};
